import { Navigate, Route, Routes } from 'react-router-dom';

import { getToken, isAdmin } from './api.js';
import Layout from './components/Layout.jsx';
import Login from './components/Login.jsx';
import Dashboard from './components/Dashboard.jsx';
import Mandanten from './components/Mandanten.jsx';
import MandantDetail from './components/MandantDetail.jsx';
import Events from './components/Events.jsx';
import EventDetail from './components/EventDetail.jsx';
import CourseSettings from './components/CourseSettings.jsx';
import CourseSettingEventDetail from './components/CourseSettingEventDetail.jsx';
import Totara from './components/Totara.jsx';
import TotaraSettingDetail from './components/TotaraSettingDetail.jsx';
import Users from './components/Users.jsx';

// Schützt eine Route: ohne Token → Redirect auf /login.
function RequireAuth({ children }) {
    if (!getToken()) return <Navigate to="/login" replace />;
    return children;
}

// Adminrechte verlangen, sonst zurück zum Dashboard.
function RequireAdmin({ children }) {
    if (!isAdmin()) return <Navigate to="/" replace />;
    return children;
}

export default function App() {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route
                path="/"
                element={
                    <RequireAuth>
                        <Layout />
                    </RequireAuth>
                }
            >
                <Route index element={<Dashboard />} />
                <Route path="mandanten" element={<Mandanten />} />
                <Route path="mandanten/:id" element={<MandantDetail />} />
                <Route path="events" element={<Events />} />
                <Route path="events/:id" element={<EventDetail />} />
                <Route path="kurseinstellungen" element={<CourseSettings />} />
                <Route path="kurseinstellungen/:id" element={<CourseSettingEventDetail />} />
                <Route path="totara" element={<Totara />} />
                <Route path="totara/:id" element={<TotaraSettingDetail />} />
                <Route
                    path="users"
                    element={
                        <RequireAdmin>
                            <Users />
                        </RequireAdmin>
                    }
                />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
